<div [className]="theme?.root + ' bg-no-repeat bg-center bg-cover'" [style]="theme?.bgImage">
  <div class="container {{ theme?.container }}" #layout>
    @if (contentCardTitle) {
      <div
        class="wysiwyg sm:px-v-spacing max-w-container mx-auto"
        [innerHTML]="contentCardTitle"
      ></div>
    }

    <div [className]="'section-container flex items-center justify-center ' + flexClass">
      @if (!!image && !layoutRightContent) {
        <div
        [ngClass]="{
          'lg:w-[40%]': layoutSplit,
          'lg:w-1/2': !layoutSplit
        }"
          class="image-section m-auto w-full py-v-spacing xs:p-v-spacing"
          >
          @if (!useLazyLoad) {
            <img
              src="{{ imgixService.buildImgixUrl(imageUrl) }}&fit=max"
              [alt]="image.altText ? image.altText : ''"
              width="498"
              height="358"
              class="w-full object-contain"
              fetchpriority="high"
              preloadImg
              />
          }
          @if (useLazyLoad) {
            <img
              src="{{ imgixService.buildImgixUrl(imageUrl) }}&fit=max"
              [alt]="image.altText ? image.altText : ''"
              width="498"
              height="358"
              class="w-full object-contain"
              />
          }
        </div>
      }
      @if (layoutRightContent) {
        <div
           [ngClass]="{
             'lg:w-[40%]': layoutSplit,
             'lg:w-1/2': !layoutSplit
           }"
          class="right-content m-auto w-full xs:p-v-spacing py-v-spacing">
          <div class="wysiwyg" (click)="modalWrapperClickHandler($event)" [innerHTML]="layoutRightContent"></div>
        </div>
      }
      <div
        class="p-0 w-full"
        [ngClass]="{
          'lg:w-[60%]': (!!image || layoutRightContent) && layoutSplit,
          'lg:w-1/2': (!!image || layoutRightContent) && !layoutSplit,
          'lg:pr-v-spacing': flexClass.includes('flex-row-reverse') && (!!image || isCard),
          'lg:pl-v-spacing': !flexClass.includes('flex-row-reverse') && (!!image || isCard)
        }"
        >
        <div
          class="content-section w-full xs:p-v-spacing py-v-spacing"
          [ngClass]="{
            'sm:px-v-spacing max-w-container mx-auto': !image && !isCard && !layoutRightContent,
            'flex flex-col': productPickerContent,
            'lg:flex-row': !layoutRightContent
          }"
          >
          <div
            [className]="productPickerContent && layoutSplit ? 'lg:w-[60%] lg:mr-v-spacing lg:pr-v-spacing' : 'lg:w-full lg:mr-v-spacing lg:pr-v-spacing'"
            >
            @if (layoutTitle) {
              <div class="wysiwyg !mb-4 layout-title" [innerHTML]="layoutTitle"></div>
            }
            @if (data.showTrustpilot) {
              <div class="my-v-spacing">
                <div class="flex flex-wrap content-start gap-[8px] cursor-pointer" (click)="openTrustpilot()">
                  <img
                    class="h-[28px] w-[150px]"
                    height="28"
                    width="150"
                    src="https://xgrit-ecom.imgix.net/ace/trustpilot-star-rating.svg?v=1706889351"
                    alt="Trustpilot Star Rating"
                    />
                  @if (trustpilotVerified) {
                    <div class="flex items-center text-xs xxsm:text-sm xs:text-base">
                      <span class="mr-2.5"
                        ><span class="font-extrabold">{{ trustpilotTrustScore }}/5</span> Stars</span
                        >
                      <span
                        ><span class="font-extrabold">{{ trustpilotNumberOfReviews | number }}</span> Reviews</span
                        >
                    </div>
                  }
                </div>
                  </div>
                }
                @if (layoutContent) {
                  <div class="wysiwyg" (click)="modalWrapperClickHandler($event)" [innerHTML]="layoutContent"></div>
                }
              </div>
              @if ((buttons && buttons.length > 0) || (dropdown && dropdown.length > 0) || productPickerContent) {
                <div
                  id="buttons-section"
                  [ngClass]="[buttonLayout, buttonAlignment, tertiaryLayout, productPickerContent].join(' ')"
                  [className]="getButtonSectionClasses()"
                  [class.pt-8]="layoutContent"
                  >
                  <!-- Product Picker Component -->
                  @if (productPickerContent && !hideStandaloneProductPicker) {
                    <product-picker [data]="productPickerContent"></product-picker>
                  }
                  <!-- Dropdown Component -->
                  @if (!productPickerContent && dropdown && dropdown.length > 0) {
                    <div [class.xs:mr-3]="buttons.length > 0">
                      @if (dropdown && dropdown.length > 0) {
                        <vision-dropdown [dropdownData]="dropdownData"></vision-dropdown>
                      }
                    </div>
                  }
                  @for (b of buttons; track b; let odd = $odd; let last = $last; let first = $first; let i = $index) {
                    <!-- Modal CTA -->
                    @if (!productPickerContent && isModalButton(b)) {
                      <button
                        (click)="activateModal(i)"
                class="{{
                  b.buttonStyle
                }}-button modal-cta v-button w-full md:!w-max font-bold mt-0 ml-0 mb-3 md:mb-0 lg:mb-3 xl:mb-0 lg:mr-0 {{!last && 'sm:mr-3'}}"
                        [class.cursor-pointer]="modalHasContent(i)"
                        >
                        {{ b.buttonText }}
                      </button>
                    }
                    @if (!productPickerContent && !isModalButton(b)) {
                      <vision-button
                        [style]="'width:' + buttonWidth"
                        defaultStyle="primary"
                        [data]="b"
                        class="{{ getButtonClasses(last) }}"
                      ></vision-button>
                    }
                  }
                </div>
              }
            </div>
          </div>
          @if (isCard) {
            <div
              class="card-section layout-card w-full min-w-[50%]"
              [ngClass]="{ 'bg-white md:py-0': isCardContent }"
              >
              <div class="flex-col h-full" [ngClass]="{ 'md:flex md:flex-row': isCardContent }">
                <div class="card-section__image flex-3 h-48" [ngClass]="{ 'md:h-auto': isCardContent }">
                  <div class="w-full h-full" [ngClass]="{ relative: isCardContent }">
                    <div
                      class="w-full h-full block bg-no-repeat bg-center bg-cover"
                      [style.backgroundImage]="cardImageStyle"
                    ></div>
                  </div>
                </div>
                <div
                  class="card-section__content flex-4"
            [ngClass]="{
              'm-2 -mt-8 bg-white rounded shadow-lg': !isCardContent,
              'py-v-spacing sm:px-v-spacing': cardImageStyle.length === 0,
              'p-v-spacing': cardImageStyle.length > 0
            }"
                  >
                  <div class="wysiwyg text-black" (click)="modalWrapperClickHandler($event)" [innerHTML]="cardContent"></div>
                  @if (!!cardButtonLabel) {
                    <div class="button-section mt-8">
                      <vision-button defaultStyle="tertiary" [data]="cardButtonData"></vision-button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
